import { Button } from '@src/design-system/button';
import { CalendarDays, ListFilter } from 'lucide-react';
import {
  Popover,
  PopoverClose,
  PopoverContent,
  PopoverTrigger,
} from '@src/design-system/popover';
import { RangeCalendar } from '@src/design-system/calender';
import {
  DropdownMenu,
  DropdownMenuItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@src/design-system/dropdown-menu';
import { useNotificationFilter } from '../hooks/use-notification-filters';

export const NotificationsFilter = () => {
  const {
    handleUnreadFilter,
    handleAllFilter,
    setDateRange,
    handleDateApply,
    dateRange,
  } = useNotificationFilter();
  return (
    <div className='flex ml-auto'>
      <DropdownMenu>
        <DropdownMenuTrigger>
          <Button variant={'primaryOutline'}>
            <ListFilter /> Filter
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          <DropdownMenuItem onClick={handleAllFilter}>all</DropdownMenuItem>
          <DropdownMenuItem disabled>requests </DropdownMenuItem>
          <DropdownMenuItem onClick={handleUnreadFilter}>
            unread
          </DropdownMenuItem>
          <DropdownMenuItem disabled>mentions</DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <Popover>
        <PopoverTrigger asChild>
          <Button
            variant={'primaryOutline'}
            className='mx-2'
          >
            <CalendarDays />
            Select Date
          </Button>
        </PopoverTrigger>
        <PopoverContent className='p-2 bg-white rounded-xl shadow-md border'>
          <RangeCalendar
            value={dateRange}
            onChange={setDateRange}
          />
          <PopoverClose className='flex w-[100%] justify-around mt-6'>
            <Button
              variant='primaryOutline'
              className='w-[40%]'
              size='sm'
            >
              Cancel
            </Button>
            <Button
              variant='primary'
              className='w-[40%]'
              size='sm'
              onClick={handleDateApply}
            >
              Apply
            </Button>
          </PopoverClose>
        </PopoverContent>
      </Popover>
    </div>
  );
};
